import { IconButton } from "@mui/material";
import { StyledModal } from "../../../components/Modal";
import { theme } from "../../../helpers/theme";
import UploadIcon from "@mui/icons-material/Upload";
import styled from "styled-components";
import { toast, ToastOptions } from "react-toastify";
import { useState } from "react";
import { StyledButton } from "../../../components/Button/button";
import { useMutation } from "@tanstack/react-query";
import { updateWarehousesAvailabilityExcel } from "../../../services/warehouses-availability-file-edit";

interface OperatorSubcontractorWarehousesEditAvailabilityProps {
  openAvailability: boolean,
  handleCloseAvailability: () => void,
}

const OperatorSubcontractorWarehousesEditAvailability = ({openAvailability, handleCloseAvailability} : OperatorSubcontractorWarehousesEditAvailabilityProps) => {

  const [file, setFile] = useState<File | null>(null);
  const [errorMessages, setErrorMessages] = useState<string>(); // tablica na wiadomości o błędach
  const [successMessages, setSuccessMessages] = useState<string>(); // tablica na wiadomości o sukcesach

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  toast.dismiss("400-error");

  const GetErrorFromEnum = (error_code: number) => {
    switch (error_code) {
      case 38:
        return "Brak kodu magazynu";
      case 39:
        return "Brak obszaru składowania";
      case 40:
        return "błędna powierzchnia składowania";
      case 2:
        return `Nie odnaleziono danego obszaru składowania 
         lub brak dostępności dla daty teraźniejszej`
      case 7:
        return `Nie odnaleziono danego obszaru składowania 
         lub brak dostępności dla daty teraźniejszej`
    }
  }

  const updateWarehousesAvailabilityExcelMutation = useMutation(updateWarehousesAvailabilityExcel, {
    onSuccess: (data) => {
      if (data.status === 206){
        const linie_bledy = data.data.payload.linie_bledy;
        const bledy = data.data.payload.bledy;
        const linie_sukces = data.data.payload.linie_sukces;
        const errorMessages = []; // pusta tablica na wiadomości o błędach
        const successMessages = []; // pusta tablica na wiadomości o sukcesach
        for (let i = 0; i < linie_bledy.length; i++) {
          const message = `Linia ${linie_bledy[i]}: ${GetErrorFromEnum(bledy[i])}`;
          errorMessages.push(message); // dodaj każdą wiadomość o błędzie do tablicy errorMessages
        }
        for (let i = 0; i < linie_sukces.length; i++) {
          const message = `Linia ${linie_sukces[i]}: Zaktualizowano pomyślnie.`;
          successMessages.push(message); // dodaj każdą wiadomość o sukcesie do tablicy successMessages
        }
        setErrorMessages(errorMessages.join("\n")); // połącz wszystkie wiadomości o błędach w jeden długi łańcuch znaków i przypisz do errorMessages
        if (successMessages.length > 0) {
          setSuccessMessages(successMessages.join("\n")); // wyświetl każdą wiadomość o sukcesie w osobnym zielonym powiadomieniu
        }
      } else {
        toast.success("Pomyślnie zaktualizowano dostępność", { toastId: "Success", ...settings });
      }
    },
    onError: (error:any) => {
      console.log(error.response);
      const ErrocCode = error.response.data.error_code
      if (ErrocCode === 2) {
        toast.error("Brak rekordów w pliku", { toastId: "NoRecordsFound", ...settings });
      } else if (ErrocCode === 29) {
        toast.error("Błędny rozmiar pliku", { toastId: "WrongFileSize", ...settings });
      } else if (ErrocCode === 28) {
        toast.error("Błędny format pliku", { toastId: "WrongFileFormat", ...settings });
      } else if (ErrocCode === 37) {
        toast.error('Błędne nagłówki w pliku', { toastId: "WrongHeaders", ...settings });
      }
    },
  });

  const handleFileAdd = (e: React.ChangeEvent<HTMLInputElement>) => {
    // let isCSV: Boolean =
    // e.target.files?.[0]?( (e.target.files?.[0].type === "text/csv" || e.target.files?.[0].type === "application/vnd.ms-excel") ? true : false):false;

    // if (isCSV) {
      setFile(e.target.files?.[0] ? e.target.files?.[0] : null);
    // } else {
      // toast.error("Niepoprawny format pliku", { toastId: "WrongFileFormat", ...settings });
    // }
  };

  const handleFileUpload = () => {
    if (file) {
      updateWarehousesAvailabilityExcelMutation.mutate({Dostepnosc: file});
    }
  };

  return ( 
    <StyledModal
      modalIsOpen={openAvailability}
      handleModalClose={()=>{
        handleCloseAvailability();
        setFile(null);
        setErrorMessages("");
      }}
    >
      <ButtonLoadingWrapper>
        <FileLabel isFileAdded={true}>
          <StyledLabel>
            {file ? file.name : "Wybierz plik"}
          </StyledLabel>
        </FileLabel>
        <IconButton
          color="primary"
          aria-label="upload file"
          component="label"
          sx={{
            color: `${theme.colors.black_primaryText}`,
          }}
          >
          <input
            id="updateAvailabilityFile"
            name="updateAvailabilityFile"
            hidden
            accept=".csv"
            type="file"
            style={{ marginTop: "-10px" }}
            onChange={(e) => {
              handleFileAdd(e);
            }}
            />
            <UploadIcon />
        </IconButton>
      </ButtonLoadingWrapper>
      {errorMessages && successMessages && (
        <StyledMessage>
          <StyledErrorText><pre>{errorMessages}</pre></StyledErrorText>
          <StyledSuccessText><pre>{successMessages}</pre></StyledSuccessText>
        </StyledMessage>
      )}
      <StyledButton
        style={{display:"flex", width:"200px" , justifyContent:"center", margin:"auto auto", marginTop:"20px"}}
        disabled={file ? false : true}
        onClick={() => {
          handleFileUpload();
        }}
      >
        Zapisz
      </StyledButton>
    </StyledModal>
  );
}

export default OperatorSubcontractorWarehousesEditAvailability;

const ButtonLoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: auto auto;
`;

const FileLabel = styled.div<{
  isFileAdded: boolean;
}>`
  ${(props: any) =>
    props.isFileAdded
      ? `
      font-size:12px;
      color:black;
      padding-top:18px;
      width:auto;
      `
      : 
      `
      justify-content: center;
      font-size:14px;
      color:${theme.colors.black_primaryText};
      padding-top:8px;  
      `
  };
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 8px;
`;

const StyledLabel = styled.p`
  font-size: 16px;
  width: 100%;
  font-family: ${theme.fonts.interRegular};
  color: ${theme.colors.black_primaryText};
  margin: 0;
`;

const StyledMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto auto;
  margin-top: 20px;
  width: 100%;
`;

const StyledErrorText = styled.p`
  font-size: 14px;
  width: 100%;
  font-family: ${theme.fonts.interRegular};
  color: red;
  margin: 0;
`;

const StyledSuccessText = styled.p`
  font-size: 14px;
  width: 100%;
  font-family: ${theme.fonts.interRegular};
  color: green;
  margin: 0;
`;